import { User } from './types';
import { scrubUrl } from './utils/telemetry';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pendo = (window as any).pendo;

// Pendo records the page URL, and every URL it captures, as is - and portal links carry share, report and sign-in tokens.
const PENDO_URL_TRANSFORMS = [
  { target: 'all', attr: 'href', action: 'Replace', data: (href: string): string => scrubUrl(href) }
];

export const initializePendo = (user: User) => {
  if (!pendo) return;

  const roles = user.roles.map((r) => r.name).join(', ');
  const options = {
    visitor: {
      id: user.id,
      email: user.email,
      full_name: `${user.first_name || ''} ${user.last_name || ''}`,
      role: roles
    },
    location: { transforms: PENDO_URL_TRANSFORMS }
  };
  if (user.account_id) {
    Object.assign(options, { account: { id: user.account_id, name: user.account_name } });
  }
  pendo?.initialize(options);
};
